<div container>
  <div
    class="get-screened card card--purple d-flex flex-column flex-lg-row-reverse justify-content-lg-between align-items-lg-center"
  >
    <div class="get-screened__icon mx-auto mx-lg-0">
      <img
        class="img-fluid"
        [src]="'/assets/img/how-to-screen/antibodies.svg'"
        alt="A magnifying glass looking at autoantibodies"
        width="308"
        height="308"
      />
    </div>
    <div class="get-screened__text">
      <h2 class="mb-3">Information on Screening</h2>
      <p class="mb-3">
        There are numerous ways for your patients to screen for the risk of
        developing type 1 diabetes via in-office and at home tests. <sup>1</sup>
      </p>
      <p class="mb-3">
        Unlike a blood sugar level test,<sup>2,3</sup> an autoantibody blood
        screening looks for T1D-related autoantibodies*. These are proteins
        that appear in the blood when type 1 diabetes begins, even in the early
        stages before symptoms are present.<sup>4, 5</sup>
      </p>

      <p class="mb-3">
        Screening may be low or even no cost depending on insurance.<sup>6</sup>
        Knowing there are signs of autoimmune type 1 diabetes lets people act
        early and proactively seek out monitoring and management options.<sup
          >1</sup
        >
      </p>

      <p class="mb-4">
        For more information on advising patients regarding next steps following
        positive screening results, download our Next Steps resource below.
      </p>
      <div class="d-flex justify-content-center justify-content-lg-start">
        <div
          class="btn px-0 py-0 mb-4 d-none d-lg-block"
          global-button
          [buttonData]="cardButton"
        ></div>
        <div
          class="btn px-0 py-0 mb-4 d-block d-lg-none"
          global-button
          [buttonData]="cardButtonMobile"
        ></div>
      </div>

      <p class="footnote">
        * Glutamic acid decarboxylase 65 (GAD) autoantibodies,
        Insulinoma-associated antigen 2 autoantibody (1A-2A), Zinc transporter 8
        autoantibody (ZnT8A), Islet cell autoantibody (ICA), Insulin
        autoantibody (IAA)<sup>7</sup>
      </p>
    </div>
  </div>
</div>
